import React, { useState, useEffect } from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import { Link } from "react-router-dom";
import MapContainer from "../components/MapContainer";
import CustomHelmet from "../components/CustomHelmet";
import { Spinner } from "react-bootstrap";
import axios from "axios";

const url = "https://www.hubsquares.com/php_files/viewListing.php/";
const urlBusinessHour =
  "https://www.hubsquares.com/php_files/getBusinessHour.php/";
const urlGallery =
  "https://www.hubsquares.com/php_files/fetchGallery.php/";
export default function AdminListingDetails(props) {
  const [business, setBusiness] = useState("");
  const [openingDays, setOpeningDays] = useState([]);
  const [galleries, setGalleries] = useState("");
  const [getDay, setGetDay] = useState("");

  function returnDay(n) {
    if (n === 1) return "Monday";
    else if (n === 2) return "Tuesday";
    else if (n === 3) return "Wednesday";
    else if (n === 4) return "Thursday";
    else if (n === 5) return "Friday";
    else if (n === 6) return "Saturday";
    else if (n === 7) return "Sunday";
  }
  useEffect(() => {
    if (props.match.params.listing) {
      const fetchListing = () => {
        axios
          .post(url, { refID: props.match.params.listing })
          .then((res) => setBusiness(res.data.listing[0]));
        axios
          .post(urlGallery, { refID: props.match.params.listing })
          .then((res) => {
            if (res.data.galleries) setGalleries(res.data.galleries[0]);
          });
        axios
          .post(urlBusinessHour, { refID: props.match.params.listing })
          .then((res) => {
            setOpeningDays(res.data.hours);
            let day = res.data.hours.filter(
              (r) => r.days === returnDay(new Date().getUTCDay())
            );
            setGetDay(day[0]);
          });
      };
      fetchListing();
    }
  }, [props.match.params.listing]);

  return (
    <>
      {business !== "" ? (
        <div>
          <CustomHelmet page="Listing Details" />
          <Navbar search={true} props={props} user={props.user} />
          <div
            className="wrapper details_banner position-relative"
            style={{
              backgroundImage: `url(https://www.hubsquares.com/php_files/covers/${business.cover})`,
            }}
          >
            <div className="overlay">
              <div className="banner">
                <div className=" text-left mt-6 container">
                  <h1>{business.title.toLocaleUpperCase()}</h1>
                </div>
              </div>
            </div>
          </div>

          <main className="container mb-5 details">
            <div className="navigation my-4">
              <p>
                <Link to="/" className="home">
                  Home
                </Link>{" "}
                |{" "}
                <Link to="/listings" className="home">
                  Business Services
                </Link>{" "}
                | <span> {business.title}</span>
              </p>
            </div>
            <div className="row py-3">
              <div className="col-md-7">
                <div className="d-flex align-items-center mb-2">
                  <h3 className="text-red mr-4">{business.title}</h3>
                  {business.logo && (
                    <img
                      src={`https://www.hubsquares.com/php_files/logos/${business.logo}`}
                      height="64px"
                      width="64px"
                      style={{ borderRadius: "50%" }}
                      alt={business.title}
                    />
                  )}
                </div>
                <h5 className="mb-4">{business.category}</h5>
              </div>
              <div className="col-md-5">
                <div className="d-flex align-items-center justify-content-between fs-14">
                  <div>
                    <span className="rating">{business.rating}.0</span>
                    {/* <span>1 Rating</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-8">
                <div className="my-4">
                  {<p>{business.description}</p>}
                  {
                    <div>
                      <p className="my-4">
                        For more enquiries, including beneficial business
                        relationships, please contact us at:
                      </p>
                      <p> Tel: {business.phone}.</p>
                      <p>Email: {business.linkedin}</p>
                      {business.website && <p>Website: {business.website}</p>}
                      <p> Country: {business.country}</p>
                      <p>City: {business.state}</p>
                    </div>
                  }
                </div>
                {openingDays.length < 0 && (
                  <div className="my-4">
                    <h5>Business Hours</h5>
                    <div className="">
                      {openingDays.map((day, i) => (
                        <div key={i} className="row my-2 ">
                          <span className="col-4">{day.days}</span>
                          <span className="col-8">
                            <span className="mr-2">{day.start_time}</span>
                            {day.end_time === "24 hours" ? null : (
                              <span>-</span>
                            )}
                            <span className="ml-2">{day.end_time}</span>
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <div className="my-4">
                  <h5>Business Gallery</h5>
                  <div className="row">
                    {galleries.gallery1 && (
                      <div className="col-md-6 my-3 gallery">
                        <img
                          src={`https://www.hubsquares.com/php_files/gallery/${galleries.gallery1}`}
                          style={{ borderRadius: 18 }}
                          height="90%"
                          width="90%"
                          alt={business.title}
                        />
                      </div>
                    )}
                    {galleries.gallery2 && (
                      <div className="col-md-6 my-3 gallery">
                        <img
                          src={`https://www.hubsquares.com/php_files/gallery/${galleries.gallery2}`}
                          style={{ borderRadius: 18 }}
                          height="100%"
                          width="100%"
                          alt={business.title}
                        />
                      </div>
                    )}
                    {galleries.gallery3 && (
                      <div className="col-md-6 my-3 gallery">
                        <img
                          src={`https://www.hubsquares.com/php_files/gallery/${galleries.gallery3}`}
                          style={{ borderRadius: 18 }}
                          height="100%"
                          width="100%"
                          alt={business.title}
                        />
                      </div>
                    )}
                    {galleries.gallery4 && (
                      <div className="col-md-6 my-3 gallery">
                        <img
                          src={`https://www.hubsquares.com/php_files/gallery/${galleries.gallery4}`}
                          style={{ borderRadius: 18 }}
                          height="100%"
                          width="100%"
                          alt={business.title}
                        />
                      </div>
                    )}
                    {galleries.gallery5 && (
                      <div className="col-md-6 my-3 gallery">
                        <img
                          style={{ borderRadius: 18 }}
                          src={`https://www.hubsquares.com/php_files/gallery/${galleries.gallery5}`}
                          height="100%"
                          width="100%"
                          alt={business.title}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="breadcrumb bg-light border-dark px-0 d-block">
                  <div className="row px-3 w-100">
                    <div
                      className="col-6"
                      style={{ color: getDay ? "#6DC520" : "red" }}
                    >
                      <i
                        className="fa fa-clock icon-grey mr-1"
                        aria-hidden="true"
                      ></i>
                      {getDay ? "Open Today" : "Closed"}
                    </div>
                    <div className="col-6 text-right">
                      {getDay && (
                        <p>
                          {" "}
                          {getDay.start_time} - {getDay.end_time}
                        </p>
                      )}
                    </div>
                  </div>
                  <hr />
                  <div className="px-3 d-flex align-items-start">
                    <i
                      className="fa fa-map-marker icon-grey mt-1 mr-1"
                      aria-hidden="true"
                    ></i>
                    <p>{business.googleaddress}</p>
                  </div>
                  <hr />

                  {
                    <div className="px-3 d-flex align-items-start">
                      <i
                        className="fa fa-phone icon-grey mt-1 mr-1"
                        style={{ transform: "rotate(90deg)" }}
                        aria-hidden="true"
                      ></i>
                      <p>{business.phone}</p>
                    </div>
                  }
                  {<hr className="mt-0" />}
                  {
                    <div className="px-3 d-flex align-items-start">
                      <i className="fa fa-envelope icon-grey mt-1 mr-1"></i>
                      <p>{business.linkedin}</p>
                    </div>
                  }
                  {
                    <div>
                      {business.website && (
                        <div>
                          <hr className="mt-0" />
                          <div className="px-3 d-flex align-items-start">
                            <i
                              className="fa fa-globe ml-1 icon-grey mt-1 mr-1"
                              aria-hidden="true"
                            ></i>
                            <p>{business.website}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  }
                  {<hr className="mt-0" />}
                  {
                    <div className="social d-flex align-items-center px-3 d-flex align-items-center">
                      {business.facebook && (
                        <a
                          rel="noopener noreferrer"
                          href={business.facebook}
                          target="_blank"
                        >
                          <i className="fab fa-facebook-square text-dark mr-1 fs-24"></i>
                        </a>
                      )}
                      {business.whatsapp && (
                        <a
                          rel="noopener noreferrer"
                          href={`https://Wa.me/${business.whatsapp}`}
                          target="_blank"
                        >
                          <i className="fab fa-whatsapp text-dark mr-1 fs-24"></i>
                        </a>
                      )}
                      {business.instagram && (
                        <a
                          rel="noopener noreferrer"
                          href={`${business.instagram}/`}
                          target="_blank"
                        >
                          <i className="fab fa-instagram text-dark mr-1 fs-24"></i>
                        </a>
                      )}
                      {business.twitter && (
                        <a
                          rel="noopener noreferrer"
                          href={`https://www.twitter.com/${business.twitter}`}
                          target="_blank"
                        >
                          <i className="fab fa-twitter-square text-dark mr-1 fs-24"></i>
                        </a>
                      )}
                      {business.youtube && (
                        <a
                          rel="noopener noreferrer"
                          href={`https://www.youtube.com/${business.youtube}`}
                          target="_blank"
                        >
                          <i className="fab fa-youtube-square text-dark mr-1 fs-24"></i>
                        </a>
                      )}
                    </div>
                  }
                  {<hr />}
                </div>
                {
                  <div style={{ height: 355, width: "100%" }}>
                    <MapContainer
                      lat={parseFloat(business.lat)}
                      lng={parseFloat(business.lng)}
                    />
                  </div>
                }

                {/* <div className="overflow-hidden">
                  <h4 className="text-center mt-4">Related Search</h4>
                  <ListingDetailsAdBlock
                    businessName="Klinsheet Consulting Ltd"
                    location="Okota, Lagos"
                    img={klinsheet}
                    businessService="Background Check Services"
                  />
                </div> */}
              </div>
            </div>
          </main>
          <Footer />
        </div>
      ) : (
        <div className="d-flex justify-content-center loading-h align-items-center">
          {" "}
          <Spinner className="text-red fs-24" animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      )}
    </>
  );
}
